import { Injectable } from '@angular/core';
import { getDatabase, ref, update} from "firebase/database";

@Injectable({
  providedIn: 'root'
})
export class RealtimeService {

  constructor() { }

  async updateCursorPositionOnCanvas(canvasKey: string, userId: string, position: {x: number, y: number}, name: string, isLaser: boolean, laserPoints: number[], color: string) { // update user position on map  
    const db =  getDatabase()
    return await update(ref(db, "/cursors/"+canvasKey+"/cursors/"+userId+"/"), {"x": position.x, "y": position.y, "dateOfUpdate": Date.now(), "name": name, "isLaser": isLaser, "laserPoints": laserPoints, "color": color || ""}).then(() => {
    })
  }
}
